import React from 'react';
import classNames from 'classnames';
import Icon from 'components/styleguide/icon/Icon';

const styles = require('./SocialButton.module.scss');

export type SocialProvider = 'Google' | 'Microsoft' | 'Linkedin' | 'Facebook' | 'Github';

export interface SocialButtonProps {
  className?: string;
  dataMethod?: string;
  href: string;
  provider: SocialProvider;
  rel?: string;
  target?: string;
}

const SocialButton: React.FC<SocialButtonProps> = ({
  className,
  dataMethod = 'post',
  href,
  provider,
  rel,
  target,
}) => {
  const label = `Sign in with ${provider}`;

  return (
    <a
      href={href}
      target={target}
      rel={rel || (target === '_blank' ? 'noopener noreferrer' : undefined)}
      data-method={dataMethod}
      className={classNames(styles.socialButton, className)}
      aria-label={label}
    >
      <Icon name={provider.toLowerCase()} size="md" aria-hidden="true" />
      <span>{provider}</span>
    </a>
  );
};

export default SocialButton;
